import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  expandCell: {
    fontSize: 20,
    width: CELL_WIDTHS.EXPAND.DEPTH_1,
    minWidth: CELL_WIDTHS.EXPAND.DEPTH_1,
    position: "sticky !important",
    left: CELL_WIDTHS.DRAG_HANDLE,
    zIndex: 3,
    "&.d2": {
      width: CELL_WIDTHS.EXPAND.DEPTH_2,
      minWidth: CELL_WIDTHS.EXPAND.DEPTH_2,
    },
    "&.d3": {
      width: CELL_WIDTHS.EXPAND.DEPTH_3,
      minWidth: CELL_WIDTHS.EXPAND.DEPTH_3,
    },
  },
}));

export default useStyle;
